import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Book, User, Info } from 'lucide-react';

export default function BottomNav() {
  const location = useLocation();

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-black/50 border-t border-white/5 py-3 z-50 backdrop-blur-xl">
      <div className="flex justify-around items-center">
        <Link to="/" className={`flex flex-col items-center gap-1 ${location.pathname === '/' ? 'text-primary' : 'text-slate-400'} hover:text-white transition`}>
          <Home size={24} />
          <span className="text-xs uppercase tracking-widest">Главная</span>
        </Link>
        <Link to="/courses" className={`flex flex-col items-center gap-1 ${location.pathname.startsWith('/courses') ? 'text-primary' : 'text-slate-400'} hover:text-white transition`}>
          <Book size={24} />
          <span className="text-xs uppercase tracking-widest">Курсы</span>
        </Link>
        <Link to="/about" className={`flex flex-col items-center gap-1 ${location.pathname === '/about' ? 'text-primary' : 'text-slate-400'} hover:text-white transition`}>
          <Info size={24} />
          <span className="text-xs uppercase tracking-widest">О нас</span>
        </Link>
        <Link to="/profile" className={`flex flex-col items-center gap-1 ${location.pathname === '/profile' ? 'text-primary' : 'text-slate-400'} hover:text-white transition`}>
          <User size={24} />
          <span className="text-xs uppercase tracking-widest">Профиль</span>
        </Link>
      </div>
    </nav>
  );
}